module.exports = __webpack_public_path__ + "img/programmer-and-coding-concept.27ee4fea.jpeg";